export const AudioPlayerQueryKey = {
    audioPeaks: (audioId: string, sourceId: string) => ['audio', audioId, 'peaks', sourceId],
}
